import { Alert, Box, Typography } from '@mui/material';
import { COLORS } from '../../../../utils/Application_Constants';

export default function PreInvoiceStatusErrorsBanner({ message, type, errors = [], onClose }) {
    return (
        <Box
            sx={{
                mb: 2,
                maxHeight: '130px',
                overflowY: 'auto',
            }}
        >
            <Alert severity={type} onClose={onClose}>
                <Typography
                    variant="body2"
                    sx={{
                        mt: '1px',
                        fontWeight: 400,
                        color: type === 'success' ? COLORS.LT_EMERALD150 : COLORS.LT_PEPPER150,
                    }}
                >
                    {message}
                </Typography>
                {errors.length > 0 && (
                    <Box component="ul" sx={{ mt: '1px' }}>
                        {errors.map((errorMessage, index) => (
                            <li key={index}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mt: '1px',
                                        fontWeight: 400,
                                        color:
                                            type === 'success'
                                                ? COLORS.LT_EMERALD150
                                                : COLORS.LT_PEPPER150,
                                    }}
                                >
                                    {errorMessage}
                                </Typography>
                            </li>
                        ))}
                    </Box>
                )}
            </Alert>
        </Box>
    );
}
